module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    ref: "mychart",
    staticStyle: {
      "width": "18rem",
      "height": "18rem"
    },
    attrs: {
      "id": "mychart"
    }
  }), _vm._v(" "), _c('card', {
    attrs: {
      "header": {
        title: '基本资料'
      }
    }
  }, [_c('div', {
    staticClass: "card-padding",
    slot: "content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("出生年月")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail"
  }, [_vm._v("1992/12/26")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("籍贯")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail"
  }, [_vm._v("江西省高安市")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("学历")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail"
  }, [_vm._v("本科11级")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("毕业时间")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail"
  }, [_vm._v("2015/06/30")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("毕业学校")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail"
  }, [_vm._v("杭州电子科技大学")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("专业")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail"
  }, [_vm._v("电子信息工程")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail"
  }, [_vm._v("18906702695")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail"
  }, [_vm._v("18906702695@163.com")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("状态")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail"
  }, [_vm._v("离职,正在找工作")])])])]), _vm._v(" "), _c('card', {
    attrs: {
      "header": {
        title: '求职意向'
      }
    }
  }, [_c('div', {
    staticClass: "card-padding",
    slot: "content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("目标职位")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail",
    staticStyle: {
      "flex": "2"
    }
  }, [_vm._v("前端工程师")])])])]), _vm._v(" "), _c('card', {
    attrs: {
      "header": {
        title: '工作经历'
      }
    }
  }, [_c('div', {
    staticClass: "card-padding",
    slot: "content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("2015.3-2017.3")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail",
    staticStyle: {
      "flex": "2"
    }
  }, [_vm._v("上海华测导航技术股份有限公司")])])])]), _vm._v(" "), _c('card', {
    attrs: {
      "header": {
        title: '教育经历'
      }
    }
  }, [_c('div', {
    staticClass: "card-padding",
    slot: "content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("2011.9-2015.6")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail",
    staticStyle: {
      "flex": "2"
    }
  }, [_vm._v("杭州电子科技大学")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("英语")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail",
    staticStyle: {
      "flex": "2"
    }
  }, [_vm._v("CET-6")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-cat"
  }, [_vm._v("计算机")]), _vm._v(" "), _c('div', {
    staticClass: "info-detail",
    staticStyle: {
      "flex": "2"
    }
  }, [_vm._v("计算机二级C")])])])]), _vm._v(" "), _c('card', {
    attrs: {
      "header": {
        title: '自我评价'
      }
    }
  }, [_c('div', {
    staticClass: "card-padding",
    slot: "content"
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._v("\n        1活泼好动，积极主动\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n        2有强烈的上进心和求知欲，善于学习和运用新知识，很喜欢前端\n      ")])])]), _vm._v(" "), _c('card', {
    attrs: {
      "header": {
        title: '专业技能'
      }
    }
  }, [_c('div', {
    staticClass: "card-padding",
    slot: "content"
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._v("\n       1语言：HTML5,CSS3,JS,XML,JSON,AJAX \n       ")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n       2前端框架：JQUERY MOBILE,VUE,JQUERY EASYUI,BOOTSTRAP \n      ")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n       3编辑器：Adobe Dreamweaver,Visual Studio Code,Sublime \n      ")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n       4操作系统：Windows,linux\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n       5浏览器：Google Chrome， IE，Firefox \n      ")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n       6Github 网址: https://github.com/huangbin1/\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n       7两年PC端和移动端前端开发经验。\n      ")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/huangbin.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "photo-info"
  }, [_c('p', [_vm._v("黄彬")]), _vm._v(" "), _c('p', [_vm._v("求职意向：前端工程师")]), _vm._v(" "), _c('p', [_vm._v("工作年限：2年")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "contact"
  }, [_c('a', {
    attrs: {
      "href": "https://www.zhihu.com/people/xiaxiaowen-68"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/contactImage/zhihu.png")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://weibo.com/2624719700/profile?topnav=1&wvr=6"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/contactImage/weibo.png")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://sns.liepin.com/main/5674995339j3099828089"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/contactImage/lieping.png")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/huangbin1"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/contactImage/QQ.png")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/huangbin1"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/contactImage/wechart.png")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/huangbin1"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/contactImage/github.png")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-367c3ca5!./~/.1.0.50@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/user.vue
// module id = 92
// module chunks = 0